import axiosInstance from "../AxiosInstance";

export const getCmsStaticPage = (slug) => {
    return axiosInstance.get(`/page/get/${slug}`)
}